import { useEffect } from 'react';
import { supabase } from 'utils/supabaseClient';
import FitLogo from 'assets/images/logos/FitLogo.png';
import { buildAppUrl } from 'utils/appUrl';

export default function AuthStart() {

    useEffect(() => {

        supabase.auth.signInWithOAuth({
            provider: 'google',
            options: {
                redirectTo: buildAppUrl('/auth/callback'),
                flow: 'pkce',
            },
        });
    }, []);

    return <div className='h-full w-full flex items-center justify-center flex-col' style={{ background: 'linear-gradient(to bottom, transparent, color-mix(in srgb, var(--primary) 50%, transparent))' }}>
        {/* loader */}
        <div className="loader relative">
            <div className="spinner w-28 h-28 rounded-full animate-spin border-t-[6px] border-b-[6px] border-white">
            </div>
            <img src={FitLogo} alt="Loading..." className='absolute inset-0 m-auto p-4' />
        </div>
        <p className="text-center text-white p-8 font-bold">Logging in with Google...</p>
    </div>;

}
